import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  min-height: 100vh;
  background-color: var(--color-bg);
  padding: 120px 0 80px;
`;

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 24px;
`;

const EventLayout = ({ children }) => {
  return (
    <Container>
      <Content>
        {children}
      </Content>
    </Container>
  );
};

export default EventLayout;